import React from 'react'
import { Flex } from '@components'
import { Form, Input, Row, Col, Button, Modal, Upload, Icon, message, Spin, InputNumber, Select, Tooltip } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import { createUuid, getLoginUser } from '@utils/NHCore'
import NHFetch from '@utils/NHFetch'
const Dragger = Upload.Dragger
import CommonTip from '@pages/SelfHelp/common'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import NHFormItem from '@components/common/NHFormItem'
import NHSelect from '@components/common/NHSelect'
import styles from './index.css'

const { TextArea } = Input
const FormItem = Form.Item
const formItemLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 }
}
const Option = Select.Option

@Form.create()
export default class Channel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mkbz: 'GD043',
      hjmc: '',
      uploading: false,
      loading: false,
      previewVisible: false,
      fileList: [],
      data: {}, //绿色通道申请信息
      nextUrl: '',
      search: '',
      operable: true, //是否显示环节
      nonOperationalData: {}, //不可操作的数据
      judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
      judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'], //可以导入的非图片格式
      yjfyInfo: {},
      btnObjList: [],
      editable: false,
    }
  }

  componentDidMount() {
    this.queryQztjAndYlhj(operable => {
      if (operable) {
        this.getBtnObject()
        this.loadLstdInfo()
        this.updateZzbdBlzt()
        this.getHjBlZt();
      }
    })
  }

  getHjBlZt = () => {
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid)
      return;
    NHFetch(`/zzbd/getBlztByHjdm`, 'GET', {
      xsid,
      hjdm: this.state.mkbz,
    }).then(res => {
      if (!res || res.code !== 200) return
      this.setState({ editable: res.data !== '1' })
    })
  }

  commonSaveLinkTransactionStatus = () => {
    let zzbdhjid = this.getQueryString('pkid');
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    let postData = {
      'zzbdhjid': zzbdhjid,
      'xsid': xsid
    }
    NHFetch('/zzbd/commonSaveLinkTransactionStatus', 'POST', postData).then(res => {
          if (res?.code == 200) {
            message.success("已确认办理");
            this.reloadMenu();
            this.setState({editable: false})
          }
        });
  }

  //迎新现场已办理时迎新网站自动办理
  updateZzbdBlzt = () => {
    let zzbdhjid = this.getQueryString('pkid')
    NHFetch('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD043' }).then(res => {
      if (res.data) {
        this.reloadMenu()
      }
    })
  }

  //查询前置条件和依赖环节
  queryQztjAndYlhj = callback => {
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    let zzbdhjid = this.getQueryString('pkid')
    NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(res => {
      if (res && res.data) {
        let kfsj = res.data['kfsj']
        let ylhj = res.data['ylhj']
        let qzhj = res.data['qzhj']
        let nohj = res.data['nohj']
        this.setState({ nonOperationalData: res.data })
        if (kfsj && kfsj['YXSJ'] != '1') {
          this.setState({ operable: false })
        }

        if (ylhj && ylhj.length > 0) {
          this.setState({ operable: false })
        }

        if (qzhj && qzhj.length > 0) {
          this.setState({ operable: false })
        }

        if (nohj) {
          this.setState({ operable: false })
        }

        if (callback) {
          callback(this.state.operable)
        }
      }
    })
  }

  getQueryString = name => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  setMenuList = menuList => {
    let nextCount = 0
    let bz = this.state.mkbz
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC
        this.setState({ hjmc: hjmc })
        nextCount = index + 1
        return
      }
    })
    let menu = menuList[nextCount]
    if (menu) {
      let hjdm = menu.HJDM
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm]
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = '/customLink'
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: ''
      })
    }
  }

  //读取学生的绿色通道信息
  loadLstdInfo = () => {
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    NHFetch('/zzbd/lstd/getLstdInfoByXsid', 'GET').then(resData => {
      this.setState({ yjfyInfo: resData.data?.yjfyInfo || {} })
      if (resData && resData.data && resData.data.lstdInfo) {
        this.setState({ data: resData.data.lstdInfo })
        let fileList = []
        if (resData.data.lstdInfo && resData.data.lstdInfo['fj']) {
          resData.data.lstdInfo['fj'].map((elem, index) => {
            //格式化对于附件取值
            let file = {
              uid: elem.fjid,
              name: elem.fjmc,
              response: {
                data: {
                  ssbh: elem.fjid,
                  fjmc: elem.fjmc
                }
              },
              status: 'done'
            }
            fileList.push(file)
          })
        }
        this.setState({ fileList: fileList })
        this.props.form.setFieldsValue({ fj: { fileList: this.state.fileList } })
      } else {
        this.setState({ data: {} })
        this.setState({ fileList: [] })
        this.props.form.resetFields()
      }
    })
  }

  // 转化base64
  getBase64 = (img, callback) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  // 点击文件链接或预览图标时的回调
  handlePreview = file => {
    const isImage = /^image\/.*$/i.test(file.type)
    if (isImage) {
      if (file) {
        this.getBase64(file, imageUrl => {
          this.setState({
            previewImage: imageUrl,
            previewVisible: true
          })
        })
      } else {
        this.setState({
          previewImage: file.url || file.thumbUrl,
          previewVisible: true
        })
      }
    } else if (file && file['response'] && file['response']['data']) {
      //其他情况
      let isImage = true
      let fjmc = file['response']['data']['fjmc']
      let ssbh = file['response']['data']['ssbh']
      if (!this.setJudge(fjmc, this.state.judgeImgList)) {
        isImage = false
      }

      if (isImage) {
        this.showPreview(`anonymity/docrepo/download/file?attachmentId=${ssbh}`)
      } else {
        window.open(`anonymity/docrepo/download/file?attachmentId=${ssbh}`)
      }
    }
  }

  showPreview = url => {
    this.setState({
      previewImage: url,
      previewVisible: true
    })
  }

  // 关闭图片弹窗
  handleCancel = () => this.setState({ previewVisible: false })

  // 提交
  handleSubmit = e => {
    this.setState({ loading: true })
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        this.setState({ loading: false })
        return false
      }

      let pkid = values['pkid']
      let xsid = getLoginUser().userId
      let zzbdhjid = this.getQueryString('pkid')
      let fjlist = []

      // 处理附件
      // if (values.dklx !== 'hb_qt') {
      //   const fj = values['fj']
      //   let isEmpty = false
      //   if (fj) {
      //     if (fj['fileList'] && fj['fileList'].length > 0) {
      //       isEmpty = false
      //     } else {
      //       isEmpty = true
      //     }
      //   } else {
      //     isEmpty = true
      //   }

      //   if (isEmpty) {
      //     this.props.form.setFields({
      //       fj: {
      //         value: undefined,
      //         errors: [new Error('请上传材料证明')]
      //       }
      //     })
      //     this.setState({ loading: false })
      //     return false
      //   }

      //   let size = fj['fileList'].length
      //   let file = fj['fileList'].filter(file => {
      //     if (file.status === 'error') {
      //       return false
      //     }
      //     return true
      //   })
      //   if (file.length != size) {
      //     this.props.form.setFields({
      //       fj: {
      //         value: fj,
      //         errors: [new Error('材料上传出错，请重新上传.')]
      //       }
      //     })
      //     this.setState({ loading: false })
      //     return false
      //   }

      //   let fileList = fj['fileList']
      //   for (let i = 0; i < fileList.length; i++) {
      //     let fjid = fileList[i].response.data.ssbh
      //     let fjmc = fileList[i].name
      //     fjlist.push({
      //       fjid: fjid,
      //       fjmc: fjmc
      //     })
      //   }
      // }

      let params = {
        ...values,
        fj: fjlist,
        xsid,
        pkid,
        zzbdhjid
      }

      if (!pkid) {
        NHFetch('/zzbd/lstd/insert', 'POST', params)
          .then(res => {
            if (res) {
              message.success('绿色通道申请保存成功。')
              this.loadLstdInfo()
              this.reloadMenu()
            }
            this.setState({ loading: false })
          })
          .catch(res => {
            this.setState({ loading: false })
            return res
          })
      } else {
        NHFetch('/zzbd/lstd/update', 'POST', params)
          .then(res => {
            if (res && res.data && res.data > 0) {
              message.success('绿色通道申请保存成功。')
              this.loadLstdInfo()
              this.reloadMenu()
            } else {
              message.warning('绿色通道申请保存失败，请重试。')
            }
            this.setState({ loading: false })
          })
          .catch(res => {
            this.setState({ loading: false })
            return res
          })
      }
    })
  }

  handleChange = ({ fileList }) => {
    let count = 0
    fileList.map(elem => {
      if (elem && elem['status'] && elem['status'] === 'uploading') {
        this.setState({ uploading: true })
        return
      } else if (elem && elem['status']) {
        count++
      }
    })
    if (count > 0) {
      this.setState({ uploading: false })
    }
  }

  //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
  setJudge = (name, map) => {
    let flag = false
    map.map(item => {
      if (name.indexOf(item) !== -1) {
        flag = true
      }
    })
    return flag
  }

  beforeUpload = file => {
    if (!(this.setJudge(file.name, this.state.judgeImgList) || this.setJudge(file.name, this.state.judgeFileList))) {
      message.error('不能上传该格式文件')
      return false
    } else {
      return true
    }
  }

  remove = ssbh => {
    let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`
    NHFetch(url, 'POST').then(res => {
      if (res.data && res.data > 0) {
        message.success('已删除材料.')
      }
    })
  }

  //重新加载菜单
  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }


  // 获取按钮名称以及跳转链接
  getBtnObject = (key) => {
    let btnObjList = []
    let url = `api/zhxg-yxwz/ydyxlstd/getButtonUrl?isMobile=0&key=${key}`
    NHFetch(url, 'GET').then(res => {
      // console.log(res.data, "---------res.data----")
      if (res.data) {
        btnObjList = res.data || []
        this.setState({ btnObjList: btnObjList })
      }
    })
  }

  goTo = (url) => {
    window.open(url, '_blank')
    // window.open("https://bing.com", '_blank')
  }

    

    

    


  render() {
    const { form } = this.props
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { previewImage, previewVisible, data, yjfyInfo, btnObjList } = this.state
    const props = {
      name: 'file',
      action: 'zuul/docrepo/upload',
      data: { uuid: createUuid(), type: '1' },

      onRemove: file => {
        this.setState(
          ({ fileList }) => {
            const index = fileList.indexOf(file)
            const newFileList = fileList.slice()
            newFileList.splice(index, 1)
            this.props.form.setFieldsValue({ fj: { fileList: newFileList } })
            return {
              fileList: newFileList
            }
          },
          () => {
            if (file.response && file.response.data && file.response.data.ssbh) {
              this.remove(file.response.data.ssbh)
            }
          }
        )
      },
      beforeUpload: file => {
        if (!this.beforeUpload(file)) {
          return false
        }
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file]
        }))
        return true
      },
      onChange: file => {
        this.handleChange(file)
      },
      onPreview: this.handlePreview,
      fileList: this.state.fileList
    }

    let edit = false
    if (JSON.stringify(data) == '{}' || !data) {
      edit = true
    }

    let btn01Img = require('@images/channelDllgdx/btn01.png')
    let btn02Img = require('@images/channelDllgdx/btn02.png')

    return (
      <div style={{ position: 'relative' }}>
        {this.state.operable ? (
          <div>
            <Flex className="w1180 mt-20" align="start">
              <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到" mkbz={this.state.mkbz} menuType="自助报到" />
              <Flex.Item className="page_con_r" styleName="">
                <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
                <div className="box">
                  <Hint />
                  <TitleTop title="绿色通道申请" extra={false} />
                  {btnObjList && btnObjList.length > 0 && (
                    <div className={styles.content}>

                      <div className={styles.typeBtnBox}>
                        <div className={styles.typeBtn} style={{ backgroundImage: `url(${btn02Img})` }} onClick={() => { this.goTo(btnObjList[0].WZ) }}>
                          {btnObjList[0].ANM}
                          <div className={styles.styleBox}></div>
                        </div>
                        {
                            btnObjList.length > 1 &&
                            <div className={styles.typeBtn} style={{backgroundImage: `url(${btn02Img})`}}
                                 onClick={() => {
                                   this.goTo(btnObjList[1].WZ)
                                 }}>
                              {btnObjList[1].ANM}
                            </div>
                        }
                        {
                            btnObjList.length > 2 &&
                            <div className={styles.typeBtn} style={{backgroundImage: `url(${btn02Img})`}}
                                 onClick={() => {
                                   this.goTo(btnObjList[2].WZ)
                                 }}>
                              {btnObjList[2].ANM}
                            </div>
                        }
                      </div>
                      <div className={styles.typeBtnBox}>
                        {
                            btnObjList.length > 3 &&
                            <div className={styles.typeBtn} style={{backgroundImage: `url(${btn02Img})`}}
                                 onClick={() => {
                                   this.goTo(btnObjList[3].WZ)
                                 }}>
                              {btnObjList[3].ANM}
                            </div>
                        }
                        {
                            btnObjList.length > 4 &&
                            <div className={styles.typeBtn} style={{backgroundImage: `url(${btn02Img})`}}
                                 onClick={() => {
                                   this.goTo(btnObjList[4].WZ)
                                 }}>
                              {btnObjList[4].ANM}
                            </div>
                        }
                      </div>
                    </div>
                  )}

                  <div className="text-center mt-50">
                    {this.state.editable && (
                        <Button type='primary' onClick={this.commonSaveLinkTransactionStatus}>
                          以上均不申请
                        </Button>
                    )}
                    <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                  </div>
                </div>
              </Flex.Item>
            </Flex>
            <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
              <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
            <Spin style={{ position: 'absolute', top: '300px', left: '60%' }} spinning={this.state.loading} />{' '}
          </div>
        ) : (
          <CommonTip hjmc={'绿色通道申请'} key={'GD043'} mkbz="GD043" nonOperationalData={this.state.nonOperationalData} />
        )}
      </div>
    )
  }
}
